// Generated by ts-to-zod
import { iPlaceZodSchema } from 'shared/zod-models/place'
import { z } from 'zod'

export const metaDataSchema = z.object({
  numberOfRolls: z.number(),
  lastPlace: iPlaceZodSchema,
})

export type MetaData = z.infer<typeof metaDataSchema>
